import React from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Carousel from "../../Carousel";
import Portfolio from "../../Portfolio";
import RecoverySection from "../../Recovery";
import { counters } from "../../Constants/Counters";

const FreeNapkin = () => {
  const bannersItems = [
    {
      img: "assets/img/m-napkin/S-1.jpg",
      // title: "Temporibus autem quibusdam",
      // description:
      //   "Beatae vitae dicta sunt explicabo.  enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt omnis iste natus error sit voluptatem accusantium.",
    },
  ];

  const portfolioImage = [
    {
      img: "assets/img/m-napkin/G-1.jpg",
      title: "A New Era of Dignity: Inauguration of the Free Sanitary Napkin Initiative",
      description:
        "In a heartfelt ceremony, community leaders and volunteers gathered to inaugurate the Free Sanitary Napkin Initiative.",
    },
    {
      img: "assets/img/m-napkin/G-2.jpg",
      title: "Breaking Barriers: Launch of the Free Sanitary Napkin Initiative",
      description:
        "In a vibrant ceremony, the Free Sanitary Napkin Initiative was officially launched, bringing hope and support to women and girls in the community.",
    },
    {
      img: "assets/img/m-napkin/G-3.jpg",
      title: "Collecting Hope: Empowering Women Through Menstrual Hygiene",
      description:
        "Community members gather to collect free sanitary napkins, promoting menstrual health and dignity. This initiative fosters awareness and support, ensuring every woman has access to essential hygiene products",
    },
  ];


  return (
    <main className="main">
      <Carousel bannersItems={bannersItems} />
      <RecoverySection
        counters={[counters[8]]}
      />

      <Portfolio
        portfolioHeader="Empowering Women: Free Sanitary Napkin Initiative"
        description="Mallabhum Prayas is a transformative initiative aimed at providing free sanitary napkins to women and girls in underserved communities. Recognizing the critical importance of menstrual hygiene, the program seeks to eliminate barriers that prevent access to essential sanitary products, particularly for those from low-income backgrounds. By distributing sanitary napkins through local schools, community centers, and health clinics, Mallabhum Prayas ensures that women can manage their menstrual health with dignity and comfort.

        In addition to product distribution, the initiative conducts educational workshops that focus on menstrual hygiene management. These sessions aim to empower women and girls with knowledge about their bodies, dispel myths surrounding menstruation, and promote healthy practices. Community involvement is a cornerstone of the initiative, with local volunteers playing a vital role in outreach and education.

         Mallabhum Prayas also emphasizes sustainability by exploring eco-friendly alternatives to traditional sanitary products, such as reusable and biodegradable options. Through partnerships with NGOs and local organizations, the initiative strives to expand its reach and impact. By addressing both the practical and educational aspects of menstrual health, Mallabhum Prayas is making significant strides toward improving the lives of women and girls, fostering dignity, health, and empowerment in the community."
        portfolioImage={portfolioImage}
      />
    </main>
  );
};

export default FreeNapkin;
